<template>
  <div class="smaller-container-wrapper full-height">
    <h2 class="pt-0 mb-0 mb-sm-4 pb-sm-2">{{ $t('message.eCommerceV2.contactDetailsFormHeading') }}</h2>
    <p>{{ $t('message.eCommerceV2.contactDetailsFormMsg') }}</p>
    <contact-form
      ref="contactForm"
      @contactFormSuccessfullySubmitted="createLead"
      :button-text="buttonText"
    ></contact-form>
    <div class="push-down-desktop mt-3">
      <mobialis-button class="mb-3" @click="submit()" data-cy="continue">{{ buttonText }}</mobialis-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { enumMixin } from '@/mixins';
import ContactForm from '@/components/shared/ContactForm.vue';
import helperFunctions from '@/utils/helperFunctions';
import { AVAnalyticsEventTriggers } from '@/utils/enums';

export default {
  name: 'ContactFormWrapper',
  components: {
    ContactForm,
  },
  mixins: [enumMixin],
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['getCurrentProduct']),
    isTradeSubFlow() {
      return this.$route.path.includes('trade-in/trade-in-contact-form');
    },
    buttonText() {
      if (this.isTradeSubFlow) {
        return this.$t('message.eCommerceV2.contactDetailsFormTradeBtn');
      }
      return this.$t('message.common.continue');
    },
    isEcomV2() {
      return this.getCurrentProduct === this.enums.AVRProducts.ECOMV2;
    },
  },
  methods: {
    submit() {
      this.$refs.contactForm.submitContactForm();
    },
    async createLead() {
      helperFunctions.sendAVAnalyticsEvent(this.$route.path, AVAnalyticsEventTriggers.FORM_SUBMIT, this.$store);
      const payload = this.isEcomV2 ? { subType: this.enums.SubType.ECOMV2 } : null;
      try {
        this.$store.commit('SET_LOADING', true);
        await this.$store.dispatch('lead/createLead', payload);
        this.$router.push({ path: this.getNextRoutePath() });
        this.$store.commit('SET_LOADING', false);
      } catch (err) {
        this.$log('Error in contact form createLead', err);
        this.$router.push('error');
        this.$store.commit('SET_LOADING', false);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
